import type { ReactNode } from 'react';
import { Header } from './Header';
import { BottomNav } from './BottomNav';

interface AppShellProps {
  children: ReactNode;
  siteName: string;
  /** Timestamp of the LAST reading in the sheet (frozen), not the fetch time. */
  lastDataAt: Date | null;
  refreshing: boolean;
  onRefresh: () => void;
}

export function AppShell({
  children, siteName, lastDataAt, refreshing, onRefresh,
}: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header
        siteName={siteName}
        lastDataAt={lastDataAt}
        refreshing={refreshing}
        onRefresh={onRefresh}
      />
      <main
        className="flex-1 max-w-screen-md w-full mx-auto px-4 pad-safe-bottom-lg"
      >
        {children}
      </main>
      <BottomNav />
    </div>
  );
}